import { EyeIcon, EyeOffIcon } from 'lucide-react';
import { forwardRef, useState } from 'react';

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
    color?: string;
    className?: string;
};

const PasswordInput = forwardRef<HTMLInputElement, Props>(({ color, className, ...props }, ref) => {
    const [show, setShow] = useState(false);

    const borderColor = color === 'failure' ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-blue-500 focus:ring-blue-500';

    return (
        <div className="relative">
            <input
                {...props}
                ref={ref}
                type={show ? 'text' : 'password'}
                className={`block w-full rounded-lg border bg-gray-50 p-2.5 text-sm text-gray-900 pr-10 focus:outline-none focus:ring-1 ${borderColor} ${className ?? ''}`}
            />
            <button
                type="button"
                tabIndex={-1}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => setShow(v => !v)}
                className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700"
            >
                {show ? <EyeOffIcon size={16} /> : <EyeIcon size={16} />}
            </button>
        </div>
    );
});

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
